<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="side-frame"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          ShipmentNo: {{ formData.contractNo || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ $l('INDEX.form_bookingType') || '订舱类型' }}:
          {{ formData.v_bookingType || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ $l('INDEX.form_label_plannedETD') || '计划发运日期' }}:
          {{ formData.plannedETD || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ $l('INDEX.form_quotedMethod') || '报价方式' }}:
          {{ formData.v_quotedMethod || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ $l('INDEX.form_shipmentType') || '发运方式' }}:
          {{ formData.v_shipmentType || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ $l('INDEX.table_label_customer_name') || '客户名称' }}:
          {{ formData.custName || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ $l('INDEX.table_label_endcustomer_name') || '终端客户' }}:
          {{ formData.endCustName || '--' }}
        </span>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form
          ref="form"
          size="mini"
          :model="formData"
          :rules="rules"
          :show-message="showMessage"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.table_label_destinationPort') || '目的港口'"
              >
                <el-select
                  v-model="formData.destinationPort"
                  :placeholder="
                    $l('INDEX.placeholder_destinationPort') || '请选择目的港口'
                  "
                  filterable
                  size="mini"
                  clearable
                  style="width:100%"
                  @change="onDestinationPortChange"
                >
                  <el-option
                    v-for="item in portData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('INDEX.form_label_destinationPortFullName') || '指运港'
                "
              >
                <dict-select
                  v-model="formData.destinationPortFullName"
                  :placeholder="
                    $l('INDEX.form_placeholder_destinationPortFullName') ||
                      '请选择指运港'
                  "
                  url="/master/port/fullNameSelect"
                  size="mini"
                  clearable
                  filterable
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.form_destinationCountry') || '目的国'"
                prop="destinationCountry"
              >
                <dict-select
                  v-model="formData.destinationCountry"
                  :placeholder="
                    $l('INDEX.form_placeholder_destinationCountry') ||
                      '请选择目的国'
                  "
                  url="/master/port/countrySelect"
                  size="mini"
                  clearable
                  filterable
                >
                </dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_vessel') || '船名'"
                prop="vessel"
              >
                <el-input
                  v-model.trim="formData.vessel"
                  :placeholder="
                    $l('INDEX.form_placeholder_vessel') || '请选择输入船名'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_voyage') || '航次'"
                prop="voyage"
              >
                <el-input
                  v-model.trim="formData.voyage"
                  :placeholder="
                    $l('INDEX.form_placeholder_voyage') || '请选择输入航次'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_label_bookingDate') || '订舱日期'"
              >
                <el-date-picker
                  v-model="formData.bookingDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.form_placeholder_bookingDate') || '请选择订舱日期'
                  "
                  style="width: 100%"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_deliveryDate') || '产装日期'"
                prop="deliveryDate"
              >
                <el-date-picker
                  v-model="formData.deliveryDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.form_placeholder_deliveryDate') ||
                      '请选择实际产装日期'
                  "
                  style="width: 100%"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_closingDate') || '开船日期'"
                :prop="shipmentStatus == 'S' ? 'closingDate' : ''"
              >
                <el-date-picker
                  v-model="formData.closingDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.form_placeholder_closingDate') || '请选择开船日期'
                  "
                  style="width: 100%"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="!['B', 'L', 'C'].includes(shipmentStatus)">
              <el-form-item
                :label="$l('INDEX.form_label_eta') || '进仓/到港日期'"
              >
                <el-date-picker
                  v-model="formData.eta"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.form_placeholder_eta') || '请选择进仓/到港日期'
                  "
                  style="width: 100%"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="!['B', 'L', 'C'].includes(shipmentStatus)">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_label_cfdDate') || '提交清关文件日期'"
                :prop="shipmentStatus == 'S' ? 'cfdDate' : ''"
              >
                <el-date-picker
                  v-model="formData.cfdDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.form_placeholder_cfdDate') ||
                      '请选择提交清关文件日期'
                  "
                  style="width: 100%"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_label_pfdDate') || '提交付款文件日期'"
                :prop="shipmentStatus == 'S' ? 'pfdDate' : ''"
              >
                <el-date-picker
                  v-model="formData.pfdDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.form_placeholder_pfdDate') ||
                      '请选择提交付款文件日期'
                  "
                  style="width: 100%"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_label_actualETD') || '实际开船日期'"
              >
                <el-date-picker
                  v-model="formData.actualETD"
                  :placeholder="
                    $l('INDEX.form_placeholder_actualETD') ||
                      '请选择实际开船日期'
                  "
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  clearable
                />
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row
            :gutter="10"
            v-if="shipmentStatus !== 'B' && shipmentStatus !== 'L'"
          >
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_domesticShipperCode') || '境内发货人'"
                prop="domesticShipperCode"
              >
                <dict-select
                  url="/factory/shipment/customer/select"
                  v-model="formData.domesticShipperCode"
                  :body="shipperParams"
                  :placeholder="
                    $l('INDEX.form_placeholder_domesticShipperCode') ||
                      '请选择境内发货人'
                  "
                  size="mini"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_overseasConsigneeCode') || '境外收货人'"
                prop="overseasConsigneeCode"
              >
                <dict-select
                  url="/factory/shipment/customer/select"
                  v-model="formData.overseasConsigneeCode"
                  :body="consigneeParams"
                  :placeholder="
                    $l('INDEX.form_placeholder_overseasConsigneeCode') ||
                      '请选择境外收货人'
                  "
                  size="mini"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="10"
            v-if="shipmentStatus !== 'C' && shipmentStatus !== 'L'"
          >
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_shipper') || '发货人'"
                prop="shipperCode"
              >
                <dict-select
                  url="/factory/shipment/customer/select"
                  v-model="formData.shipperCode"
                  :body="shipperParams"
                  :placeholder="
                    $l('INDEX.form_placeholder_shipper') || '请选择发货人'
                  "
                  size="mini"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('INDEX.form_consignee') || '收货人'"  :prop="'consigneeCode'">
                <dict-select
                  url="/factory/shipment/customer/select"
                  v-model="formData.consigneeCode"
                  :body="consigneeParams"
                  :placeholder="
                    $l('INDEX.form_placeholder_consignee') || '请选择收货人'
                  "
                  size="mini"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('INDEX.form_notifier') || '通知人'">
                <dict-select
                  url="/factory/shipment/customer/select"
                  v-model="formData.notifierCode"
                  :body="notifierParams"
                  :placeholder="
                    $l('INDEX.form_placeholder_notifier') || '请选择通知人'
                  "
                  size="mini"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.form_bookingScm') || '订舱货代'"
                prop="bookingScmCode"
              >
                <dict-select
                  v-model="formData.bookingScmCode"
                  url="/master/common/dict/xzScmPartners"
                  size="mini"
                  :placeholder="
                    $l('INDEX.form_placeholder_bookingScm') || '请选择订舱货代'
                  "
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.form_customsBrokerScmCode') || '报关货代'"
                prop="customsBrokerScmCode"
              >
                <dict-select
                  v-model="formData.customsBrokerScmCode"
                  url="/master/common/dict/xzScmPartners"
                  size="mini"
                  :placeholder="
                    $l('INDEX.form_placeholder_customsBrokerScm') ||
                      '请选择报关货代'
                  "
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.form_transitScm') || '运输公司'"
                prop="transitScmCode"
              >
                <dict-select
                  v-model="formData.transitScmCode"
                  url="/master/common/dict/xzScmPartners"
                  size="mini"
                  :placeholder="
                    $l('INDEX.form_placeholder_transitScm') || '请选择运输公司'
                  "
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="d-flex justify-content-end mt-2 mb-2">
            <el-button type="primary" size="small" @click="save()">
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-form>
      </el-col>
      <el-col :span="16">
        <el-row :gutter="10">
          <ContainerTable
            v-if="shipmentStatus === 'M' || shipmentStatus === 'S'"
            :shipmentCode="shipmentCode"
            :shipmentBookingCode="shipmentBookingCode"
            :height="375"
            ref="containerTable"
          />
        </el-row>
        <el-row :gutter="10" class="mt-1">
          <ContainerBookingPoTable
            :shipmentCode="shipmentCode"
            :shipmentBookingCode="shipmentBookingCode"
            :shipmentStatus="shipmentStatus"
            :custCode="custCode"
          />
        </el-row>
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ContainerBookingPoTable from '../container-booking-po'
import ContainerTable from '../container'
import { request } from '@/api/service'
export default {
  mixins: [EditLoading],
  components: { ContainerBookingPoTable, ContainerTable },
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    shipmentStatus: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        destinationPortFullName: '',
        destinationCountry: '',
      },
      backDialogVisible: false,
      showMessage: false,
      rules: {
        destinationPort: [
          {
            required: true,
            message:
              this.$l('INDEX.placeholder_destinationPort') || '请选择目的港口',
            trigger: 'change',
          },
        ],
        destinationCountry: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_destinationCountry') ||
              '请选择目的国',
            trigger: 'change',
          },
        ],
        deliveryDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_deliveryDate') ||
              '请输入产装日期',
            trigger: 'change',
          },
        ],
        // bookingDate: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('INDEX.form_placeholder_bookingDate') || '请选择订舱日期',
        //     trigger: 'change',
        //   },
        // ],
        closingDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_closingDate') || '请选择开船日期',
            trigger: 'change',
          },
        ],
        cfdDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_cfdDate') || '请选择提交清关文件日期',
            trigger: 'change',
          },
        ],
        pfdDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_pfdDate') || '请选择提交付款文件日期',
            trigger: 'change',
          },
        ],
        consigneeCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_consigneeCode') || '请选择收货人',
            trigger: 'change',
          },
        ],
        bookingScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_bookingScm') || '请选择订舱货代',
            trigger: 'change',
          },
        ],
        customsBrokerScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_customsBrokerScm') ||
              '请选择报关货代',
            trigger: 'change',
          },
        ],
        shipperCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_shipper') || '请选择发货人',
            trigger: 'change',
          },
        ],
        domesticShipperCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_domesticShipperCode') ||
              '请选择境内发货人',
            trigger: 'change',
          },
        ],
        overseasConsigneeCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_overseasConsigneeCode') ||
              '请选择境外收货人',
            trigger: 'change',
          },
        ],
        transitScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_transitScm') || '请选择运输公司',
            trigger: 'change',
          },
        ],
      },
      portData: [],
    }
  },
  computed: {
    shipperParams() {
      return { shipmentType: 'S', custCode: this.custCode }
    },
    consigneeParams() {
      return { shipmentType: 'C', custCode: this.custCode }
    },
    notifierParams() {
      return { shipmentType: 'C', custCode: this.custCode }
    },
  },
  mounted() {
    this.loadData()
    this.selectPort()
  },
  methods: {
    loadData() {
      if (!this.shipmentCode || !this.shipmentBookingCode) return
      this.showMessage = false
      this.$api
        .shipmentBookingDetailApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .then((res) => {
          this.formData = res.body
          setTimeout(() => {
            this.showMessage = true
            this.$refs.form.clearValidate()
          }, 1000)
        })
        .catch(() => {
          setTimeout(() => {
            this.showMessage = true
            this.$refs.form.clearValidate()
          }, 1000)
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const params = {
        ...this.formData,
        shipmentCode: this.shipmentCode,
        shipmentBookingCode: this.shipmentBookingCode,
      }
      this.loadingOpen()
      this.$api
        .shipmentBookingSaveApi(params)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          if (!this.shipmentBookingCode) {
            this.shipmentBookingCode = res.body
            this.loadData()
            return
          }
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
    },
    selectPort() {
      request({
        url: '/master/port/select',
        method: 'POST',
      }).then((res) => {
        this.portData = res.body.data
      })
    },
    onDestinationPortChange(e) {
      const data = this.portData.filter((item) => item.value === e)[0]
      if (!data) return
      const { portCountry, portFullName } = data
      this.formData.destinationPortFullName = portFullName || ''
      this.formData.destinationCountry = portCountry || ''
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame,
.side-frame-success,
.side-frame-danger,
.side-frame-warning {
  padding: 1px 5px;
  height: 20px;
  margin: 8px 0;
}
</style>
